import React, { useEffect } from 'react';
export var WindowEventListener = function (props) {
    useEffect(function () {
        if (props.onKeyDown) {
            window.addEventListener('keydown', props.onKeyDown);
        }
        return function () {
            if (props.onKeyDown) {
                window.removeEventListener('keydown', props.onKeyDown);
            }
        };
    }, []);
    return (React.createElement(React.Fragment, null, props.children));
};
